module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0, false, false)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "deprecation-banner"
  }, [_c('img', {
    staticClass: "lightbulb",
    attrs: {
      "src": require("../assets/img/lightbulb.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h3', {
    staticClass: "header"
  }, [_vm._v("We thought you'd like to know...")]), _vm._v(" "), _c('p', {
    staticClass: "content-copy"
  }, [_vm._v("\n      You are currently viewing the Opentrons APIv1 Protocol Library. We've recently released\n      "), _c('a', {
    attrs: {
      "href": "https://docs.opentrons.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Opentrons APIv2")]), _vm._v(", and as such the APIv1 library\n      will no longer be updated.\n      "), _c('b', [_vm._v("Opentrons App and Robot Software version 4.0.0 and later will no longer support APIv1.")]), _vm._v("\n      Please visit the new\n      "), _c('a', {
    attrs: {
      "href": "https://protocols.opentrons.com",
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v("Opentrons APIv2 Protocol Library")]), _vm._v("\n      to access the most up-to-date protocols.\n    ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e34b1424!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeprecationBanner.vue
// module id = 166
// module chunks = 2